// import { useEffect, useState, useMemo } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import MDBox from "components/MDBox";
// import MDInput from "components/MDInput";
// import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
// import { useMaterialUIController } from "context";
// import DashboardNavbar from "examples/Navbars/DashboardNavbar";
// import FilterCard from "./components/filterCard";
// import Projects from "layouts/dashboard/components/Projects";
// import GoogleMapView from "./googleMapView";
// import SearchIcon from "@mui/icons-material/Search";
// import InputAdornment from "@mui/material/InputAdornment";
// import CloseIcon from "@mui/icons-material/Close";
// import AssignReplacementDialog from "layouts/Planning/components/AssignReplacementDialog";
// import { Skeleton } from "@mui/material";
// import FloatingTopButtons from "./components/floatingsearchbutton";
// import left from "../../assets/images/left.png";
// import { SIDEBAR_WIDTH, SIGNAL, GLASS, RADIUS } from "./theme/uiTokens";

// // 👇 REDUX ACTIONS IMPORT (Path check kar lena apne project ke hisab se)
// import {
//   fetchInitialFleetData,
//   fetchFleetUpdates,
//   setSelectedVehicleNumber,
//   setActiveFilter,
//   resetShouldRefreshThings,
//   refreshFleetData,
//   setSearchQuery
// } from "../../features/live_map/fleetSlice";

// function Dashboard() {
//   const [controller] = useMaterialUIController();
//   const { darkMode } = controller;
//   const dispatch = useDispatch();

//   // 👇 UI Animation ke liye local state (Sidebar slide effect)
//   const [isVisible, setIsVisible] = useState(false);

//   // 👇 REDUX SE DATA LE RAHE HAIN
//   const {
//     myThings,
//     latestUpdates,
//     geoFences,
//     loading,
//     selectedVehicleNumber,
//     activeFilter,
//     searchQuery,
//     // resetShouldRefreshThings,
//     shouldRefreshThings
//   } = useSelector((state) => state.fleet || {});

//   useEffect(() => {
//     if (shouldRefreshThings) {
//       dispatch(refreshFleetData());

//       dispatch(resetShouldRefreshThings());
//     }
//   }, [shouldRefreshThings, dispatch]);

//   useEffect(() => {
//     if (!myThings) {
//       dispatch(fetchInitialFleetData());
//     }

//     const pollInterval = setInterval(() => {
//       if (myThings) {
//         const thingIds = Object.keys(myThings);
//         dispatch(fetchFleetUpdates(thingIds));
//       }
//     }, 6000);

//     return () => clearInterval(pollInterval);
//   }, [dispatch, myThings]);

//   // 🎭 SIDEBAR ANIMATION TIMING
//   useEffect(() => {
//     if (activeFilter) {
//       setTimeout(() => setIsVisible(true), 10);
//     } else {
//       setIsVisible(false);
//     }
//   }, [activeFilter]);

//   const handleFilterSelect = (filterType) => {
//     if (selectedVehicleNumber) {
//       dispatch(setSelectedVehicleNumber(null));
//       dispatch(setSearchQuery(filterType));
//       dispatch(setActiveFilter(filterType));
//       return;
//     }

//     if (activeFilter === filterType) {
//       if (filterType !== "@total") {
//         dispatch(setSearchQuery("@total"));
//         dispatch(setActiveFilter("@total"));
//       }
//     } else {
//       dispatch(setSearchQuery(filterType));
//       dispatch(setActiveFilter(filterType));
//     }
//   };

//   // const handleFilterSelect = (filterType) => {
//   //   if (activeFilter === filterType) {
//   //     if (filterType !== "@total") {
//   //       dispatch(setSearchQuery("@total"));
//   //       dispatch(setActiveFilter("@total"));
//   //     }
//   //   } else {
//   //     dispatch(setSearchQuery(filterType));
//   //     dispatch(setActiveFilter(filterType));
//   //   }
//   // };

//   const handleVehicleSelect = (vehicleNumber) => {
//     dispatch(setSearchQuery(vehicleNumber));
//     dispatch(setSelectedVehicleNumber(vehicleNumber));
//   };

//   const handleCloseFilter = () => {
//     setIsVisible(false);
//   };

//   // const handleOpenFilter = () => {
//   //   if (!activeFilter) {
//   //     dispatch(setActiveFilter("@total"));
//   //     dispatch(setSearchQuery("@total"));
//   //   } else {
//   //     dispatch(setSearchQuery(activeFilter));
//   //   }

//   //   setTimeout(() => setIsVisible(true), 10);
//   // };

//   const handleOpenFilter = () => {
//     if (!activeFilter) {
//       dispatch(setActiveFilter("@total"));
//       dispatch(setSearchQuery("@total"));
//     } else {
//       if (!selectedVehicleNumber) {
//         dispatch(setSearchQuery(activeFilter));
//       }
//     }

//     setTimeout(() => setIsVisible(true), 10);
//   };

//   // Inside Dashboard.js
//   const filteredVehicles = useMemo(() => {
//     if (!myThings || !latestUpdates) return [];

//     const now = Date.now();
//     const entries = Object.entries(myThings);

//     // If total or no filter, show everything in myThings
//     if (!activeFilter || activeFilter === "@total") return entries;

//     return entries.filter(([key, thing]) => {
//       // IMPORTANT: Path must match your Redux state structure
//       const update = latestUpdates[key];
//       const latest = update?.latest?.GPS || update?.latest?.MOBILE || {};

//       const speed = parseFloat(latest?.speed ?? 0);
//       const ignition = latest?.raw?.IGNITION?.toString() ?? "";
//       const updatedAt = latest?.updatedAt ?? 0;
//       const isStale = updatedAt + 3600000 < now; // 1 hour offline check

//       switch (activeFilter) {
//         case "@offline":
//           return isStale;
//         case "@running":
//           return !isStale && ignition === "1" && speed >= 0.25;
//         case "@idle":
//           return !isStale && ignition === "1" && speed < 0.25;
//         case "@parked":
//           return !isStale && ignition === "0";
//         case "@onroute":
//           return thing?.journeyAvailable === true;
//         default:
//           return true;
//       }
//     });
//   }, [myThings, latestUpdates, activeFilter]);

//   const responsedata = useMemo(() => ({
//     myThings: myThings || {},
//     latestUpdates: latestUpdates || {}
//   }), [myThings, latestUpdates]);

//   // const selectedVehicleJourney = filteredVehicles.find(
//   //   ([vehicleNumber]) => vehicleNumber === selectedVehicleNumber
//   // );

//   // const journeyAvailable = selectedVehicleJourney?.[1]?.journeyAvailable;

//   // console.log('selectedvehiclenummmm', selectedVehicleNumber);



//   // 🦴 SIDEBAR SKELETON COMPONENT
//   const renderSidebarSkeleton = () => (
//     <MDBox sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%", gap: 2 }}>
//       <Skeleton variant="rounded" width="100%" height={90} sx={{ borderRadius: 2 }} />
//       <Skeleton variant="rounded" width="100%" height={45} sx={{ borderRadius: 2 }} />
//       <MDBox sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2, overflow: "hidden" }}>
//         <Skeleton variant="rounded" width="100%" height={120} sx={{ borderRadius: 2 }} />
//         <Skeleton variant="rounded" width="100%" height={120} sx={{ borderRadius: 2 }} />
//         <Skeleton variant="rounded" width="100%" height={120} sx={{ borderRadius: 2 }} />
//         <Skeleton variant="rounded" width="100%" height={120} sx={{ borderRadius: 2 }} />
//       </MDBox>
//     </MDBox>
//   );

//   // 🎨 MAIN UI
//   return (
//     <DashboardLayout>
//       <DashboardNavbar />
//       <MDBox
//         mt={0} pt={0}
//         sx={{
//           position: "relative",
//           width: "calc(100% - 10px)",
//           height: "93dvh",
//           overflow: "hidden",
//           marginRight: "10px",
//         }}
//       >
//         {/* Map - Turant load hoga (bina gaadiyo ke agar data nahi hai toh) */}
//         <MDBox
//           sx={{
//             width: "100%",
//             height: "100%",
//             borderRadius: "26px",
//             overflow: "hidden",
//             boxShadow: "0 10px 40px rgba(15, 23, 42, 0.18)",
//             border: `1px solid ${darkMode ? "rgba(255,255,255,0.06)" : "rgba(15,23,42,0.06)"}`,
//           }}
//         >
//           <GoogleMapView
//             responsedata={{
//               myThings: Object.fromEntries(filteredVehicles),
//               latestUpdates: Object.fromEntries(
//                 filteredVehicles.map(([key]) => [key, responsedata.latestUpdates[key]])
//               ),
//             }}
//             selectedVehicleNumber={selectedVehicleNumber}
//             geoFences={geoFences}
//             onVehicleSelect={(vehicleNumber) => {
//               dispatch(setSearchQuery(vehicleNumber));
//               dispatch(setSelectedVehicleNumber(vehicleNumber));
//               dispatch(setActiveFilter("@total"));
//               setTimeout(() => setIsVisible(true), 10);
//             }}
//             onClearSelectedVehicleNumber={() => dispatch(setSelectedVehicleNumber(null))}
//           />
//         </MDBox>

//         {/* Floating Search Button */}
//         {!isVisible && (
//           <FloatingTopButtons
//             darkMode={darkMode}
//             demoName="Demo"
//             onSearchClick={handleOpenFilter}
//             onLogoutClick={() => {
//               localStorage.removeItem("token");
//               window.location.reload();
//             }}
//           />
//         )}

//         {/* Sidebar / Drawer */}
//         {/* {activeFilter && ( */}
//         <MDBox
//           sx={{
//             borderRadius: `${RADIUS.lg + 2}px`,
//             overflow: "hidden",
//             position: "absolute",
//             top: "10px",
//             left: "10px",
//             // height: searchQuery ? "600px" : "calc(100% - 20px)",
//             height: searchQuery?.startsWith("@")
//               ? "calc(100% - 20px)"
//               : searchQuery
//                 ? "min(600px, 82dvh)"
//                 : "calc(100% - 20px)",
//             width: {
//               xs: "calc(100% - 20px)",
//               sm: "calc(100% - 20px)",
//               md: SIDEBAR_WIDTH.md,
//               lg: SIDEBAR_WIDTH.lg,
//               xl: SIDEBAR_WIDTH.xl,
//             },
//             backgroundColor: darkMode ? GLASS.dark.panelSolid : "white",
//             backdropFilter: "blur(14px)",
//             display: "flex",
//             flexDirection: "column",
//             boxShadow: "0 16px 44px rgba(15, 23, 42, 0.22)",
//             border: `1px solid ${darkMode ? GLASS.dark.border : GLASS.light.border}`,
//             zIndex: 1,
//             transform: isVisible ? "translateX(0)" : "translateX(-110%)",
//             transition: "transform 0.3s ease, opacity 0.2s ease",
//           }}
//         >
//           {/* signal-gradient spine — the brand thread running through the panel */}
//           <MDBox sx={{ height: "3px", width: "100%", background: SIGNAL.gradient, flexShrink: 0 }} />

//           {/* 👇 CONDITION: Agar data nahi aaya toh Skeleton dikhao, warna actual UI */}
//           {!myThings ? (
//             renderSidebarSkeleton()
//           ) : (
//             <>
//               {/* Header — just the close control, kept slim */}
//               <MDBox
//                 sx={{
//                   padding: "8px 12px 0 12px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "flex-end",
//                 }}
//               >
//                 <img
//                   src={left}
//                   alt="close"
//                   style={{
//                     cursor: "pointer",
//                     width: "18px",
//                     height: "18px",
//                     opacity: darkMode ? 0.7 : 0.55,
//                     filter: darkMode ? "invert(1)" : "none",
//                     transition: "opacity 0.2s",
//                   }}
//                   onClick={handleCloseFilter}
//                   onMouseEnter={(e) => (e.currentTarget.style.opacity = 1)}
//                   onMouseLeave={(e) => (e.currentTarget.style.opacity = darkMode ? 0.7 : 0.55)}
//                 />
//               </MDBox>

//               {/* Filter Tags (includes the fleet-health spectrum bar) */}
//               <MDBox
//                 sx={{
//                   padding: "8px 12px 10px 12px",
//                 }}
//               >
//                 <FilterCard
//                   responsedata={responsedata}
//                   onFilterSelect={handleFilterSelect}
//                   activeFilter={activeFilter}
//                 />
//               </MDBox>

//               {/* Search Bar */}
//               <MDBox
//                 sx={{
//                   margin: "0 12px 10px 12px",
//                   position: "sticky",
//                   top: 0,
//                   zIndex: 1000,
//                   display: "flex",
//                   alignItems: "center",
//                   padding: "6px 14px",
//                   borderRadius: `${RADIUS.pill}px`,
//                   background: darkMode ? GLASS.dark.inset : "#f1f5f9",
//                   border: `1px solid ${darkMode ? GLASS.dark.border : GLASS.light.border}`,
//                 }}
//               >
//                 <MDInput
//                   placeholder="Search vehicle..."
//                   fullWidth
//                   value={searchQuery}
//                   onChange={(e) => dispatch(setSearchQuery(e.target.value))}
//                   sx={{
//                     "& .MuiInputBase-root:before, & .MuiInputBase-root:after": { display: "none" },
//                   }}
//                   InputProps={{
//                     disableUnderline: true,
//                     startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" /></InputAdornment>,
//                     endAdornment: searchQuery && (
//                       <CloseIcon
//                         fontSize="small"
//                         sx={{ cursor: "pointer", opacity: 0.6, "&:hover": { opacity: 1 } }}
//                         onClick={() => {
//                           dispatch(setSearchQuery(""));
//                           dispatch(setSelectedVehicleNumber(null));
//                           dispatch(setActiveFilter("@total")); // 🔥 Set to null to trigger default view
//                         }}
//                       />
//                     )
//                   }}
//                 />
//               </MDBox>

//               {/* Scrollable Results */}
//               <MDBox
//                 sx={{
//                   flex: 1,
//                   overflowY: selectedVehicleNumber ? "" : "auto",
//                   WebkitOverflowScrolling: "touch",
//                   background: darkMode ? "rgba(255,255,255,0.02)" : "#f8fafc",
//                   padding: "4px 10px 8px 10px",
//                   "&::-webkit-scrollbar": { width: "6px" },
//                   "&::-webkit-scrollbar-thumb": {
//                     background: darkMode ? "rgba(255,255,255,0.15)" : "#d1d5db",
//                     borderRadius: "4px",
//                   },
//                   "&::-webkit-scrollbar-track": {
//                     background: "transparent",
//                   },
//                 }}
//               >
//                 <Projects
//                   responsedata={{
//                     myThings: Object.fromEntries(filteredVehicles),
//                     latestUpdates: Object.fromEntries(
//                       filteredVehicles.map(([key]) => [key, responsedata.latestUpdates[key]])
//                     ),
//                   }}
//                   searchQuery={searchQuery.startsWith("@") ? "" : searchQuery}
//                   onVehicleSelect={handleVehicleSelect}
//                   selectedVehicleNumber={selectedVehicleNumber}
//                   sx={{
//                     display: "flex",
//                     flexDirection: "column",
//                     gap: 1,
//                   }}
//                 />
//               </MDBox>
//             </>
//           )}
//         </MDBox>
//       </MDBox>
//       <AssignReplacementDialog />
//     </DashboardLayout>
//   );
// }

// export default Dashboard;

import { useEffect, useState, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import MDBox from "components/MDBox";
import MDInput from "components/MDInput";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import { useMaterialUIController } from "context";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import FilterCard from "./components/filterCard";
import Projects from "layouts/dashboard/components/Projects";
import GoogleMapView from "./googleMapView";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@mui/material/InputAdornment";
import CloseIcon from "@mui/icons-material/Close";
import AssignReplacementDialog from "layouts/Planning/components/AssignReplacementDialog";
import { Skeleton } from "@mui/material";
import FloatingTopButtons from "./components/floatingsearchbutton";
import left from "../../assets/images/left.png";
import { SIDEBAR_WIDTH, SIGNAL, GLASS, RADIUS } from "./theme/uiTokens";

// 👇 REDUX ACTIONS IMPORT (Path check kar lena apne project ke hisab se)
import {
  fetchInitialFleetData,
  fetchFleetUpdates,
  setSelectedVehicleNumber,
  setActiveFilter,
  resetShouldRefreshThings,
  refreshFleetData,
  setSearchQuery
} from "../../features/live_map/fleetSlice";

function Dashboard() {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const dispatch = useDispatch();

  // 👇 UI Animation ke liye local state (Sidebar slide effect)
  const [isVisible, setIsVisible] = useState(false);

  // 👇 REDUX SE DATA LE RAHE HAIN
  const {
    myThings,
    latestUpdates,
    geoFences,
    loading,
    selectedVehicleNumber,
    activeFilter,
    searchQuery,
    // resetShouldRefreshThings,
    shouldRefreshThings
  } = useSelector((state) => state.fleet || {});

  useEffect(() => {
    if (shouldRefreshThings) {
      dispatch(refreshFleetData());

      dispatch(resetShouldRefreshThings());
    }
  }, [shouldRefreshThings, dispatch]);

  useEffect(() => {
    if (!myThings) {
      dispatch(fetchInitialFleetData());
    }

    const pollInterval = setInterval(() => {
      if (myThings) {
        const thingIds = Object.keys(myThings);
        dispatch(fetchFleetUpdates(thingIds));
      }
    }, 6000);

    return () => clearInterval(pollInterval);
  }, [dispatch, myThings]);

  // 🎭 SIDEBAR ANIMATION TIMING
  useEffect(() => {
    if (activeFilter) {
      setTimeout(() => setIsVisible(true), 10);
    } else {
      setIsVisible(false);
    }
  }, [activeFilter]);

  const handleFilterSelect = (filterType) => {
    if (selectedVehicleNumber) {
      dispatch(setSelectedVehicleNumber(null));
      dispatch(setSearchQuery(filterType));
      dispatch(setActiveFilter(filterType));
      return;
    }

    if (activeFilter === filterType) {
      if (filterType !== "@total") {
        dispatch(setSearchQuery("@total"));
        dispatch(setActiveFilter("@total"));
      }
    } else {
      dispatch(setSearchQuery(filterType));
      dispatch(setActiveFilter(filterType));
    }
  };

  // const handleFilterSelect = (filterType) => {
  //   if (activeFilter === filterType) {
  //     if (filterType !== "@total") {
  //       dispatch(setSearchQuery("@total"));
  //       dispatch(setActiveFilter("@total"));
  //     }
  //   } else {
  //     dispatch(setSearchQuery(filterType));
  //     dispatch(setActiveFilter(filterType));
  //   }
  // };

  const handleVehicleSelect = (vehicleNumber) => {
    dispatch(setSearchQuery(vehicleNumber));
    dispatch(setSelectedVehicleNumber(vehicleNumber));
  };

  const handleCloseFilter = () => {
    setIsVisible(false);
  };

  // const handleOpenFilter = () => {
  //   if (!activeFilter) {
  //     dispatch(setActiveFilter("@total"));
  //     dispatch(setSearchQuery("@total"));
  //   } else {
  //     dispatch(setSearchQuery(activeFilter));
  //   }

  //   setTimeout(() => setIsVisible(true), 10);
  // };

  const handleOpenFilter = () => {
    if (!activeFilter) {
      dispatch(setActiveFilter("@total"));
      dispatch(setSearchQuery("@total"));
    } else {
      if (!selectedVehicleNumber) {
        dispatch(setSearchQuery(activeFilter));
      }
    }

    setTimeout(() => setIsVisible(true), 10);
  };

  // Inside Dashboard.js
  const filteredVehicles = useMemo(() => {
    if (!myThings || !latestUpdates) return [];

    const now = Date.now();
    const entries = Object.entries(myThings);

    // If total or no filter, show everything in myThings
    if (!activeFilter || activeFilter === "@total") return entries;

    return entries.filter(([key, thing]) => {
      // IMPORTANT: Path must match your Redux state structure
      const update = latestUpdates[key];
      const latest = update?.latest?.GPS || update?.latest?.MOBILE || {};

      const speed = parseFloat(latest?.speed ?? 0);
      const ignition = latest?.raw?.IGNITION?.toString() ?? "";
      const updatedAt = latest?.updatedAt ?? 0;
      const isStale = updatedAt + 3600000 < now; // 1 hour offline check

      switch (activeFilter) {
        case "@offline":
          return isStale;
        case "@running":
          return !isStale && ignition === "1" && speed >= 0.25;
        case "@idle":
          return !isStale && ignition === "1" && speed < 0.25;
        case "@parked":
          return !isStale && ignition === "0";
        case "@onroute":
          return thing?.journeyAvailable === true;
        default:
          return true;
      }
    });
  }, [myThings, latestUpdates, activeFilter]);

  const responsedata = useMemo(() => ({
    myThings: myThings || {},
    latestUpdates: latestUpdates || {}
  }), [myThings, latestUpdates]);

  // const selectedVehicleJourney = filteredVehicles.find(
  //   ([vehicleNumber]) => vehicleNumber === selectedVehicleNumber
  // );

  // const journeyAvailable = selectedVehicleJourney?.[1]?.journeyAvailable;

  // console.log('selectedvehiclenummmm', selectedVehicleNumber);



  // 🦴 SIDEBAR SKELETON COMPONENT
  const renderSidebarSkeleton = () => (
    <MDBox sx={{ p: 2, display: "flex", flexDirection: "column", height: "100%", gap: 2 }}>
      <Skeleton variant="rounded" width="100%" height={90} sx={{ borderRadius: 2 }} />
      <Skeleton variant="rounded" width="100%" height={45} sx={{ borderRadius: 2 }} />
      <MDBox sx={{ flex: 1, display: "flex", flexDirection: "column", gap: 2, overflow: "hidden" }}>
        <Skeleton variant="rounded" width="100%" height={120} sx={{ borderRadius: 2 }} />
        <Skeleton variant="rounded" width="100%" height={120} sx={{ borderRadius: 2 }} />
        <Skeleton variant="rounded" width="100%" height={120} sx={{ borderRadius: 2 }} />
        <Skeleton variant="rounded" width="100%" height={120} sx={{ borderRadius: 2 }} />
      </MDBox>
    </MDBox>
  );

  // 🎨 MAIN UI
  return (
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox
        mt={0} pt={0}
        sx={{
          position: "relative",
          width: "calc(100% - 10px)",
          height: "93dvh",
          overflow: "hidden",
          marginRight: "10px",
          display: "flex",
          flexDirection: "row",
        }}
      >
        {/* Sidebar / Drawer — width animates 0 <-> SIDEBAR_WIDTH so the map reflows beside it
            instead of the sidebar floating on top of it */}
        <MDBox
          sx={{
            flexShrink: 0,
            width: isVisible
              ? {
                  xs: "calc(100% - 20px)",
                  sm: "calc(100% - 20px)",
                  md: SIDEBAR_WIDTH.md,
                  lg: SIDEBAR_WIDTH.lg,
                  xl: SIDEBAR_WIDTH.xl,
                }
              : 0,
            marginRight: isVisible ? "10px" : 0,
            transition: "width 0.3s ease, margin-right 0.3s ease",
            overflow: "hidden",
            height: "100%",
          }}
        >
          <MDBox
            sx={{
              borderRadius: `${RADIUS.lg + 2}px`,
              overflow: "hidden",
              width: {
                xs: "calc(100vw - 20px)",
                sm: "calc(100vw - 20px)",
                md: SIDEBAR_WIDTH.md,
                lg: SIDEBAR_WIDTH.lg,
                xl: SIDEBAR_WIDTH.xl,
              },
              // height: searchQuery ? "600px" : "calc(100% - 20px)",
              height: searchQuery?.startsWith("@")
                ? "calc(100% - 20px)"
                : selectedVehicleNumber
                  ? "min(400px, 82dvh)"
                  : "calc(100% - 12px)",
              mt: "10px",
              mb: "10px",
              backgroundColor: darkMode ? GLASS.dark.panelSolid : "white",
              backdropFilter: "blur(14px)",
              display: "flex",
              flexDirection: "column",
              border: `1px solid ${darkMode ? GLASS.dark.border : GLASS.light.border}`,
            }}
          >
            {/* 👇 CONDITION: Agar data nahi aaya toh Skeleton dikhao, warna actual UI */}
            {!myThings ? (
              renderSidebarSkeleton()
            ) : (
              <>
                {/* Filter Tags row — stat cards + the collapse/close arrow sit side by side,
                    same row, arrow pinned top-right like the reference design */}
                <MDBox
                  sx={{
                    padding: "10px 12px 10px 12px",
                    display: "flex",
                    alignItems: "flex-start",
                    gap: "8px",
                  }}
                >
                  <MDBox sx={{ flex: 1, minWidth: 0 }}>
                    <FilterCard
                      responsedata={responsedata}
                      onFilterSelect={handleFilterSelect}
                      activeFilter={activeFilter}
                    />
                  </MDBox>

                  <MDBox
                    onClick={handleCloseFilter}
                    sx={{
                      flexShrink: 0,
                      width: 32,
                      height: 50,
                      borderRadius: `${RADIUS.md}px`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      cursor: "pointer",
                      background: darkMode ? GLASS.dark.panel : GLASS.light.panel,
                      border: `1.5px solid ${darkMode ? GLASS.dark.border : GLASS.light.border}`,
                      boxShadow: "0 1px 6px rgba(15, 23, 42, 0.05)",
                      transition: "transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease",
                      "&:hover": {
                        transform: "translateY(-1px)",
                        boxShadow: "0 6px 16px rgba(15, 23, 42, 0.12)",
                      },
                    }}
                  >
                    <img
                      src={left}
                      alt="close"
                      style={{
                        width: "16px",
                        height: "16px",
                        opacity: darkMode ? 0.75 : 0.6,
                        filter: darkMode ? "invert(1)" : "none",
                      }}
                    />
                  </MDBox>
                </MDBox>

                {/* Search Bar */}
                <MDBox
                  sx={{
                    margin: "0 12px 10px 12px",
                    position: "sticky",
                    top: 0,
                    zIndex: 1000,
                    display: "flex",
                    alignItems: "center",
                    padding: "6px 14px",
                    borderRadius: `${RADIUS.pill}px`,
                    background: darkMode ? GLASS.dark.inset : "#f1f5f9",
                    border: `1px solid ${darkMode ? GLASS.dark.border : GLASS.light.border}`,
                  }}
                >
                  <MDInput
                    placeholder="Search vehicle..."
                    fullWidth
                    value={searchQuery}
                    onChange={(e) => dispatch(setSearchQuery(e.target.value))}
                    sx={{
                      "& .MuiInputBase-root:before, & .MuiInputBase-root:after": { display: "none" },
                    }}
                    InputProps={{
                      disableUnderline: true,
                      startAdornment: <InputAdornment position="start"><SearchIcon fontSize="small" sx={{ color: darkMode ? "#fff" : "rgb(102, 102, 102)" }} /></InputAdornment>,
                      endAdornment: searchQuery && (
                        <CloseIcon
                          fontSize="small"
                          sx={{ cursor: "pointer", opacity: 0.6, "&:hover": { opacity: 1 }, color: darkMode ? "#fff" : "rgb(102, 102, 102)" }}
                          onClick={() => {
                            dispatch(setSearchQuery(""));
                            dispatch(setSelectedVehicleNumber(null));
                            dispatch(setActiveFilter("@total")); // 🔥 Set to null to trigger default view
                          }}
                        />
                      )
                    }}
                  />
                </MDBox>

                {/* Scrollable Results */}
                <MDBox
                  sx={{
                    flex: 1,
                    overflowY: selectedVehicleNumber ? "" : "auto",
                    WebkitOverflowScrolling: "touch",
                    background: darkMode ? "rgba(255,255,255,0.02)" : "#f8fafc",
                    padding: "4px 10px 8px 10px",
                    scrollbarWidth: "none", // Firefox
                    msOverflowStyle: "none", // IE/old Edge
                    "&::-webkit-scrollbar": { display: "none" }, // Chrome/Safari/new Edge
                  }}
                >
                  <Projects
                    responsedata={{
                      myThings: Object.fromEntries(filteredVehicles),
                      latestUpdates: Object.fromEntries(
                        filteredVehicles.map(([key]) => [key, responsedata.latestUpdates[key]])
                      ),
                    }}
                    searchQuery={searchQuery.startsWith("@") ? "" : searchQuery}
                    onVehicleSelect={handleVehicleSelect}
                    selectedVehicleNumber={selectedVehicleNumber}
                    sx={{
                      display: "flex",
                      flexDirection: "column",
                      gap: 1,
                    }}
                  />
                </MDBox>
              </>
            )}
          </MDBox>
        </MDBox>

        {/* Map — takes whatever space the sidebar leaves behind, and expands to fill
            everything when the sidebar is closed */}
        <MDBox sx={{ position: "relative", flex: 1, minWidth: 0, height: "100%" }}>
          <MDBox
            sx={{
              width: "100%",
              height: "100%",
              borderRadius: "26px",
              overflow: "hidden",
              border: `1px solid ${darkMode ? "rgba(255,255,255,0.06)" : "rgba(15,23,42,0.06)"}`,
            }}
          >
            <GoogleMapView
              responsedata={{
                myThings: Object.fromEntries(filteredVehicles),
                latestUpdates: Object.fromEntries(
                  filteredVehicles.map(([key]) => [key, responsedata.latestUpdates[key]])
                ),
              }}
              selectedVehicleNumber={selectedVehicleNumber}
              geoFences={geoFences}
              onVehicleSelect={(vehicleNumber) => {
                dispatch(setSearchQuery(vehicleNumber));
                dispatch(setSelectedVehicleNumber(vehicleNumber));
                dispatch(setActiveFilter("@total"));
                setTimeout(() => setIsVisible(true), 10);
              }}
              onClearSelectedVehicleNumber={() => dispatch(setSelectedVehicleNumber(null))}
            />
          </MDBox>

          {/* Floating Search Button — anchored to the map area only */}
          {!isVisible && (
            <FloatingTopButtons
              darkMode={darkMode}
              demoName="Demo"
              onSearchClick={handleOpenFilter}
              onLogoutClick={() => {
                localStorage.removeItem("token");
                window.location.reload();
              }}
            />
          )}
        </MDBox>
      </MDBox>
      <AssignReplacementDialog />
    </DashboardLayout>
  );
}

export default Dashboard;